import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Collapse,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { styled, makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import fileBrowser from "../../icons/file-browser.svg";
import { ReactComponent as ClipIcon } from "../../assets/images/portfolio/clip.svg";
import { ReactComponent as PencilIcon } from "../../assets/images/portfolio/pencil-fill.svg";
import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import cssVariables from "../../theme/cssVariables";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Util from "../../services/global.service";

const useStyles = makeStyles({
  clickable: {
    color: "#5DA196",
    textDecoration: "underline",
    cursor: "pointer",
    "&:hover, &:focus": {
      color: "#00846e",
    },
  },
  abbreviation: {
    color: "#5DA196",
    background: "white",
    border: "1px solid #5DA196",
    padding: "0 10px",
    borderRadius: "5px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "18px!important",
  },
  iconContainer: {
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: ".5s",
    borderRadius: "5px",
    border: "1px solid white",
    "&.gray": {
      background: cssVariables.color.gray,
    },
    // "&:hover": {
    //   border: "1px solid #939393",
    // },
  },
  statusBadge: {
    minWidth: "150px",
    borderRadius: "100px",
    padding: "5px 12px",
    margin: "0",
  },
  processBg: {
    background: "#E7EEF7",
  },
  processText: {
    color: "#5387C6",
  },
  completedBg: {
    background: "rgba(93, 161, 150, 0.15);",
  },
  completedText: {
    color: "#5DA196",
  },
  expandableIcon: {
    background: "#F5F5F5",
    // padding: 3,
    width: '20px',
    height: '20px',
    borderRadius: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: '.3s',
    '&.active': {
      transform: "rotate(90deg)",
    }
  },
  paper: {
    padding: 25,
  }
});

// style accordion
const CustomizedAccordion = styled((props) => (
  <Accordion disableGutters elevation={1} square {...props} />
))(() => ({
  padding: 10,
  borderRadius: "10px",
  border: `1px solid #E4E4E4`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const CustomizedAccordionSummary = styled((props) => (
  <AccordionSummary
    expandIcon={<ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(() => ({
  backgroundColor: "white",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper": {
    background: "#F5F5F5",
    padding: 5,
    borderRadius: 3,
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: 10,
  },
}));

const CustomizedAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: "10px 0 !important",
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));
// end styled accordion
const code = (data) => {
  let text = ""
  if (data !== undefined && data !== null && data !== "" && data !== "other") {
    text = data + "- "
  }
  return text
}

const formatData = (data, defaults) => {
  if (data !== null && data !== undefined && data !== "") {
    return data;
  }
  return defaults;
}
function HaveData(props) {
  const [isCollapse, setCollapse] = React.useState(false);
  const handleCollapse = () => {
    setCollapse(!isCollapse)
  }
  const item = props.item
  const handleGoToDetail = (e) => {
    if (e.target.id !== "prevent" && e.target.parentNode.id !== "prevent" && e.target.parentNode.nodeName !== "g") {
      // navigate(`/app/workload-and-performance/${item.portfolio.serial}`, { replace: false });
      let link = `/app/workload-and-performance/${item.portfolio.serial}`
      const newWindow = window.open(link, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
  }
  const navigate = useNavigate();
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box>
      <Paper elevation={1} classes={{ root: classes.paper }} >
        <Box sx={{ padding: 0 }}>
          <Box display="flex" alignItems="center" width="100%">
            <Box mr={3} id="prevent"><div className={`clickable ${classes.expandableIcon} ${isCollapse ? 'active' : ''}`} onClick={handleCollapse} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div></Box>
            <Box mr={3} sx={{ width: "10%", maxInlineSize: "max-content", minWidth: "100px" }}>
              <Typography fontWeight="300" className={classes.abbreviation}>{formatData(item?.sourceAcronym, "-")}</Typography>
            </Box>
            <Box
              sx={{ width: "10%", minWidth: "120px", wordWrap: "break-word" }}
            >
              <Typography fontWeight="500">{formatData(item?.portfolio?.code, "-")}</Typography>
            </Box>
            <Box sx={{ width: "auto", maxWidth: item.portfolio.isEvaluated ? "25%" : "39%" }} mr={5}>
              <Typography fontWeight="500" sx={{ cursor: "pointer", textDecoration: "underline", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }} onClick={handleGoToDetail}>{item.portfolio.nameTH}</Typography>
            </Box>
            <Box sx={{ width: "auto", marginRight: "10px" }} flexGrow="1" display="flex">
              {
                item.portfolio.isEvaluated ?
                  (
                    <React.Fragment>
                      <CheckCircleIcon
                        style={{ fill: cssVariables.color.primary, marginRight: 3 }}
                      ></CheckCircleIcon>
                      <Typography color={cssVariables.color.primary} fontWeight="500">
                        ใช้เป็นภาระงาน
                      </Typography>
                    </React.Fragment>
                  )
                  : ""
              }
            </Box>
            <Box textAlign="center">
              <Typography pr={3} color={cssVariables.color.primary} fontWeight="400" color="#858585">
                {Util.dateDayTimeFormat(props?.item?.date)}
              </Typography>
            </Box>
            <Box textAlign="center">
              <Box
                className={`${classes.statusBadge} ${classes.processBg}`}
              >
                <Typography
                  className={classes.processText}
                  fontSize={15}
                  fontWeight="500"
                >
                  {item?.workStatus}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" id="prevent">
              <Box className={`${classes.iconContainer}`} mx={1}>
                {
                  item?.haveFile ?
                    (<ClipIcon></ClipIcon>)
                    : ""
                }
              </Box>
              <Box className={`${classes.iconContainer} gray clickable`} id="prevent" mx={1} onClick={() => {
                props.edit(props.item)
              }}>
                <PencilIcon id="prevent"></PencilIcon>
              </Box>
              {
                item.portfolio.isManual ?
                  <Box className={`${classes.iconContainer} gray clickable`} id="prevent" mx={1} onClick={() => {
                    props.delete(props.item)
                  }}>
                    <TrashIcon id="prevent"></TrashIcon>
                  </Box>
                  :
                  <Box sx={{ cursor: "no-drop", opacity: "0.5" }} className={`${classes.iconContainer} gray`} id="prevent" mx={1}>
                    <TrashIcon id="prevent"></TrashIcon>
                  </Box>
              }
            </Box>
          </Box>
        </Box>
        {/* <CustomizedAccordionDetails> */}
        <Collapse in={isCollapse}>
          <Grid container my={2}>
            <Grid item xs>
              <Divider />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs>
              <Typography>
                {item.portfolio.nameTH}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid item lg={12} xs={6}>
              <Grid container spacing={1}>
                <Grid item lg={2} xs={12}>
                  <Typography fontWeight="300" sx={{ color: "#A3A3A3" }}>
                    ประเภทภาระงานและผลงาน
                  </Typography>
                </Grid>
                <Grid item lg={5} xs={12}>
                  <Typography fontWeight="300" sx={{ color: "#A3A3A3" }}>
                    ประเภทภาระงานและผลงานย่อย
                  </Typography>
                </Grid>
                <Grid item lg={2} xs={12}>
                  <Typography fontWeight="300" sx={{ color: "#A3A3A3" }}>ปริมาณงานแผน</Typography>
                </Grid> 
                <Grid item lg={2} xs={12}>
                  <Typography fontWeight="300" sx={{ color: "#A3A3A3" }}>ปริมาณงานจริง</Typography>
                </Grid>
                <Grid item lg={1} xs={12}>
                  <Typography fontWeight="300" sx={{ color: "#A3A3A3" }}>กลุ่มงาน</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} xs={6}>
              <Grid container spacing={1}>
                <Grid item lg={2} xs={12}>
                  <Typography fontWeight="300">{formatData(item?.workType, "-")}</Typography>
                </Grid>
                <Grid item lg={5} xs={12}>
                  <Typography fontWeight="300">
                    {code(item?.workSubypeCode)}{item?.workSubtype}
                  </Typography>
                </Grid>
                <Grid item lg={2} xs={12}>
                  <Typography fontWeight="300">{formatData(item?.quantity, "0") + ` ` + formatData(item?.unit, "")}</Typography>
                </Grid>
                <Grid item lg={2} xs={12}>
                  <Typography fontWeight="300">{formatData(item?.quantityActual, "0") + ` ` + formatData(item?.unit, "")}</Typography>
                </Grid>
                <Grid item lg={1} xs={12}>
                  <Typography fontWeight="300">{item?.portfolio?.isWork ? "ภาระงาน" : "ผลงาน"}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* </CustomizedAccordionDetails> */}
        </Collapse>
      </Paper>
    </Box>
  );
}

function EmptyData(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        p={1}
      >
        <Box>
          <img src={fileBrowser} alt="browser" />
        </Box>
        <Box>
          <Typography>{t("portfolio.label.nodata")}</Typography>
        </Box>
        <Box>
          <Typography
            classes={{ root: classes.clickable }}
            onClick={props.onClick}
          >
            {t("portfolio.label.clickhere")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

const PortfolioCard = (props) => {
  let isEmpty = props.item ? false : true;
  const { t } = useTranslation();

  const card = (
    <Box>
      {!isEmpty ? (
        <HaveData item={props.item} delete={props.delete} edit={props.edit}></HaveData>
      ) : (
        <EmptyData onClick={props.add}></EmptyData>
      )}
    </Box>
  );

  return card;
};

export default PortfolioCard;
